import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import timeFormAPI from '../../../../api/ui/timeFormAPI';
import SimpleLine from '../ChartComponents/SimpleLine';
import {
  statisticsCarExcelDataRequest,
  statisticsCarListRequest
} from '../../../../redux/actions/monitoring/statisticsActions';
import { DAYS_AGO, DIFF_VALUE, SELECT_FORM_STYLE } from '../../../../constants/base';
import { nftGrade, nftType } from '../../../../constants/nft';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Notification from '../../../../components/Notification/Notification';
import BtnIcons from '../../../../api/images/btnIcons';
import { DatePicker } from '@mui/x-date-pickers';
import { convertBigNumToDecimalString } from '../../../../utils/convert-decimal-to-big-num';
import excelDownload from '../../../../api/excelDownload/excelDownload';
import sortKey from '../../../../api/excelDownload/sortKey';
import BOTable from "../../../../components/Tables/BOTable";
import useSchemaMonitoringMarket from "../../../../schema/table-schema/useSchemaMonitoringMarket";
import {
  SearchBtnContainer,
  SearchContainer,
  SearchContent,
  SearchDateRange,
  SearchLabel,
  SearchRow
} from "../../../../components/Search/searchSection";
import FetchLoading from "../../../../components/Loading/FetchLoading";
import DataItem from "../DataItem";

function car() {
  // -- component const --//
  // 인장
  const VehicleSeals = [
    { value: '', label: '인장 전체' },
    { value: 'None', label: 'None' },
    { value: 'Genesis', label: 'Genesis' },
    { value: 'Evolved', label: 'Evolved' },
  ];

  // 플러스여부
  const IsPlus = [
    { value: '', label: '플러스 여부 전체' },
    { value: true, label: 'O' },
    { value: false, label: 'X' },
  ];

  // 차종
  const nftTypes = Object.keys(nftType).map(key => ({
    key: nftType[key],
    value: key,
  }));

  // 차량 등급
  const nftGrades = Object.keys(nftGrade).map(key => ({
    key: nftGrade[key],
    value: key.toString(),
  }));

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  // -- state --//
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 날짜 범위
  const [activeDateRangeToken, setActiveDateRangeToken] = useState(7);

  const schema = useSchemaMonitoringMarket();

  // 데이터 설정
  const [strData, setStrData] = useState([{}]);
  const [tableData, setTableData] = useState([{}]);

  const [vehicleSealTable, setVehicleSealTable] = useState('');
  const [isPlusTable, setIsPlusTable] = useState('');
  const [NFTGradeTable, setNFTGradesTable] = useState([]);
  const [NFTTypeTable, setNFTTypesTable] = useState([]);
  const [needNftTypeTable, setNeedNftTypeTable] = useState(15);

  const [data, setData] = useState([{}]);
  const [currentData, setCurrentData] = useState([{}]);
  const [beforeData, setBeforeData] = useState([{}]);

  const [lineData, setLineData] = useState([{}]);

  const [graphType, setGraphType] = useState('count');

  const [vehicleSeal, setVehicleSeal] = useState('');
  const [isPlus, setIsPlus] = useState('');
  const [NFTGrade, setNFTGrades] = useState([]);
  const [NFTType, setNFTTypes] = useState([]);
  const [needNftType, setNeedNftType] = useState(15);

  const [isReset, setIsReset] = useState(false);

  const [startAt, setStartAt] = useState(DAYS_AGO(activeDateRangeToken));
  const [endAt, setEndAt] = useState(DAYS_AGO(1));

  // 로딩
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGraph, setIsLoadingGraph] = useState(false);

  // Excel Data
  const [excelData, setExcelData] = useState();

  // -- func & handler --//
  const handleChange = (event, type) => {
    const {
      target: { value },
    } = event;

    if (type === 'grade') {
      setNFTGrades(value);
    } else if (type === 'type') {
      setNFTTypes(value);
    } else if (type === 'grade-table') {
      setNFTGradesTable(value);
    } else if (type === 'type-table') {
      setNFTTypesTable(value);
    }
  };

  const fetchList = () => {
    setIsLoadingGraph(true);

    dispatch(
      statisticsCarListRequest({
        beginDate: startAt,
        endDate: endAt,
        nftType: Number(needNftType),
        nftGrade: NFTGrade.map(item => String(item)).join(','),
        nftSeal: vehicleSeal,
        isPlus: isPlus === '' ? null : isPlus,
        callback: (data) => {
          console.log(data);
          setData(data?.list);

          setIsLoadingGraph(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoadingGraph(false);
        },
      })
    );

    // 조회 버튼 눌리면 엑셀 범위 재설정
    // dispatch(
    //   statisticsCarExcelDataRequest({
    //     beginDate: startAt,
    //     endDate: endAt,
    //     callback: (data) => {
    //       console.log('요청 결과: ', data);
    //       setExcelData(data?.list);
    //     },
    //     error: (e) => {
    //       console.log(e);
    //       setNotificationMessage(e.toString());
    //       setShowNotification(true);
    //     }
    //   })
    // )
  };

  //
  // const handleClickDownload = () => {
  //   // 파일 명 설정
  //   const fileName = `마켓_차량_${startAt}_${endAt}`;
  //
  //   excelDownload(fileName, excelData, sortKey.statistics.market_car);
  // };

    const handleResetClick = () => {
        setStartAt(DAYS_AGO(activeDateRangeToken));
        setEndAt(DAYS_AGO(1));

        setVehicleSeal('');
        setIsPlus('');
        setNFTGrades([]);
        setNFTTypes([]);
        setNeedNftType(15);

        setIsReset(true);

    }

    useEffect(() => {
        if(!isReset){
            return;
        }

        setIsReset(false);
        fetchList();

    }, [vehicleSeal, isPlus, nftGrades, nftTypes]);

  // -- react hooks --//
  useEffect(() => {
    setStartAt(DAYS_AGO(activeDateRangeToken));
    setEndAt(DAYS_AGO(1))
  }, [activeDateRangeToken]);


  // 등록 및 거래 현황
  useEffect(() => {
    dispatch(
        statisticsCarListRequest({
          beginDate: DAYS_AGO(2),
          endDate: DAYS_AGO(1),
          nftType: Number(needNftTypeTable),
          nftGrade: NFTGradeTable.map(item => String(item)).join(','),
          nftSeal: vehicleSealTable,
          isPlus: isPlusTable === '' ? null : isPlusTable,
          callback: (data) => {
            console.log(data);

            // console.log("dayBeforeYesterdayData: ");
            // console.log(data?.list[0]);
            // setDayBeforeYesterdayData(data?.list[0]);
            //
            // console.log("currentData: ");
            // console.log(data?.list[1]);
            // setYesterdayData(data?.list[1]);

            setIsLoading(false);
          },
          error: (e) => {
            console.log(e);
            setNotificationMessage(e.toString());
            setShowNotification(true);

            setIsLoading(false);
          },
        })
    );

  }, []);


  // 등록 및 거래 현황 조회
  useEffect(() => {
    fetchList();

    setIsLoading(true);

    dispatch(
      statisticsCarListRequest({
        beginDate: DAYS_AGO(2),
        endDate: DAYS_AGO(1),
        nftType: 15,
        nftGrade: '',
        nftSeal: '',
        isPlus: isPlusTable === '' ? null : isPlusTable,
        callback: (data) => {
          setStrData(data?.list);
          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      })
    );

    // dispatch(
    //   statisticsCarExcelDataRequest({
    //     beginDate: startAt,
    //     endDate: endAt,
    //     callback: (data) => {
    //       console.log('요청 결과: ', data);
    //       setExcelData(data?.list);
    //     },
    //     error: (e) => {
    //       console.log(e);
    //       setNotificationMessage(e.toString());
    //       setShowNotification(true);
    //     }
    //   })
    // )
  }, []);


  // 등록 및 거래 현황 조회(조건 변경 시)
  useEffect(() => {
    setIsLoading(true);

    dispatch(
      statisticsCarListRequest({
        beginDate: DAYS_AGO(2),
        endDate: DAYS_AGO(1),
        nftType: Number(needNftTypeTable),
        nftGrade: NFTGradeTable.map(item => String(item)).join(','),
        nftSeal: vehicleSealTable,
        isPlus: isPlusTable === '' ? null : isPlusTable,
        callback: (data) => {
          console.log(data);
          setStrData(data?.list);

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      })
    );
  }, [needNftTypeTable, NFTGradeTable, vehicleSealTable, isPlusTable]);

  // 요청해서 온 데이터 디자인에 맞게 key 가공
  // useEffect(() => {
  //   const updateData = data?.map(data => {
  //     // 등록
  //     const registerCount = data?.registerCount || 0;
  //     const minPrice = parseFloat(convertBigNumToDecimalString(data?.registerMinPrice, 3)) || 0;
  //     const maxPrice = parseFloat(convertBigNumToDecimalString(data?.registerMaxPrice, 3)) || 0;
  //     const registerTotalPrice = parseFloat(convertBigNumToDecimalString(data?.registerTotalPrice, 3)) || 0;
  //     const registerAveragePrice = (registerTotalPrice / registerCount) || 0;
  //
  //     // 거래
  //     const transactionCount = data?.transactionCount || 0;
  //     const transactionTotalPrice = parseFloat(convertBigNumToDecimalString(data?.transactionTotalPrice, 3)) || 0;
  //     const transactionAveragePrice = (transactionTotalPrice / transactionCount) || 0;
  //     const transactionTotalFee = parseFloat(convertBigNumToDecimalString(data?.transactionTotalFee, 3)) || 0;
  //     const newDate = timeFormAPI.changeDataDate(data?.targetDate);
  //
  //     if (graphType === 'count') {
  //
  //       return {
  //         '등록 수량': registerCount || 0,
  //         '거래 수량': transactionCount || 0,
  //
  //         time: newDate
  //       };
  //
  //     } else if (graphType === 'token') {
  //
  //       return {
  //         '최저 등록 금액': minPrice || 0,
  //         '최고 등록 금액': maxPrice || 0,
  //         '평균 등록 금액': registerAveragePrice.toFixed(3) || 0,
  //         '총 거래 금액': transactionTotalPrice || 0,
  //         '평균 거래 금액': transactionAveragePrice.toFixed() || 0,
  //
  //         time: newDate
  //       };
  //
  //     } else if (graphType === 'fee') {
  //
  //       return {
  //         '총 거래 수수료': transactionTotalFee || 0,
  //
  //         time: newDate
  //       };
  //
  //     }
  //
  //     return {
  //       '등록 수량': registerCount || 0,
  //       '최저 등록 금액': minPrice || 0,
  //       '최고 등록 금액': maxPrice || 0,
  //       '평균 등록 금액': registerAveragePrice.toFixed(3) || 0,
  //       '거래 수량': transactionCount || 0,
  //       '총 거래 금액': transactionTotalPrice || 0,
  //       '평균 거래 금액': transactionAveragePrice.toFixed(3) || 0,
  //       '총 거래 수수료': transactionTotalFee || 0,
  //
  //       time: newDate
  //     };
  //   });
  //
  //   setLineData(updateData)
  // }, [data]);

  useEffect(() => {
    const updateData = strData?.map(data => {
      // 등록
      const registerCount = data?.registerCount || 0;
      const registerMinPrice = parseFloat(convertBigNumToDecimalString(data?.registerMinPrice, 3)) || 0;
      const registerMaxPrice = parseFloat(convertBigNumToDecimalString(data?.registerMaxPrice, 3)) || 0;
      const registerTotalPrice = parseFloat(convertBigNumToDecimalString(data?.registerTotalPrice, 3)) || 0;
      const registerAveragePrice = (registerTotalPrice / registerCount) || 0;

      // 거래
      const transactionCount = data?.transactionCount || 0;
      const transactionTotalPrice = parseFloat(convertBigNumToDecimalString(data?.transactionTotalPrice, 3)) || 0;
      const transactionAveragePrice = (transactionTotalPrice / transactionCount) || 0;
      const transactionTotalFee = parseFloat(convertBigNumToDecimalString(data?.transactionTotalFee, 3)) || 0;
      const targetDate = data?.targetDate;
      return {
        registerCount: registerCount,
        registerMinPrice: registerMinPrice,
        registerMaxPrice: registerMaxPrice,
        registerTotalPrice: registerTotalPrice,
        registerAveragePrice: registerAveragePrice.toFixed(3),
        transactionCount: transactionCount,
        transactionTotalPrice: transactionTotalPrice,
        transactionAveragePrice: transactionAveragePrice.toFixed(3),
        transactionTotalFee: transactionTotalFee,
        targetDate: targetDate,
      }
    });

    setTableData(updateData);

  //   ------------------------------------

    setCurrentData(parseData(strData[1]))
    setBeforeData(parseData(strData[0]))

  }, [strData]);


  const parseData = (dataItem) => {
    const registerCount = dataItem?.registerCount || 0;
    const registerMinPrice = parseFloat(convertBigNumToDecimalString(dataItem?.registerMinPrice, 3)) || 0;
    const registerMaxPrice = parseFloat(convertBigNumToDecimalString(dataItem?.registerMaxPrice, 3)) || 0;
    const registerTotalPrice = parseFloat(convertBigNumToDecimalString(dataItem?.registerTotalPrice, 3)) || 0;
    const registerAveragePrice = (registerTotalPrice / registerCount) || 0;

    const transactionCount = dataItem?.transactionCount || 0;
    const transactionTotalPrice = parseFloat(convertBigNumToDecimalString(dataItem?.transactionTotalPrice, 3)) || 0;
    const transactionAveragePrice = (transactionTotalPrice / transactionCount) || 0;
    const transactionTotalFee = parseFloat(convertBigNumToDecimalString(dataItem?.transactionTotalFee, 3)) || 0;

    return {
      registerCount,
      registerMinPrice,
      registerMaxPrice,
      registerTotalPrice,
      registerAveragePrice: registerAveragePrice.toFixed(3),
      transactionCount,
      transactionTotalPrice,
      transactionAveragePrice: transactionAveragePrice.toFixed(3),
      transactionTotalFee,
      targetDate: dataItem?.targetDate,
    };
  };

  useEffect(() => {
    let nftType = 0;
    for (let i = 0; i < NFTType.length; i += 1) {
      nftType |= 1 << NFTType[i];
    }

    setNeedNftType(nftType === 0 ? 15 : nftType);
  }, [NFTType]);

  useEffect(() => {
    let nftType = 0;
    for (let i = 0; i < NFTTypeTable.length; i += 1) {
      nftType |= 1 << NFTTypeTable[i];
    }

    setNeedNftTypeTable(nftType === 0 ? 15 : nftType);
  }, [NFTTypeTable]);

  // -- render --//
  return (
    <div>

      {/*<div className="" style={{*/}
      {/*  display: 'flex',*/}
      {/*  gap: 5,*/}
      {/*  height: 'fit-content'*/}
      {/*}}>*/}
      {/*  <div className="contentsArea" style={{*/}
      {/*    width: '100%',*/}
      {/*    height: '100%'*/}
      {/*  }}>*/}
      {/*    <div className="contentTitle flex space-between" style={{ padding: 5 }}>*/}

      {/*      <div>*/}
      {/*        등록 및 거래 현황 { `(${timeFormAPI.changeDataDate(DAYS_AGO(1))}) 기준` }*/}
      {/*      </div>*/}

      {/*      <div style={{ display: 'flex', gap: 5 }}>*/}

      {/*        <FormControl id={"formController"}>*/}
      {/*          <Select*/}
      {/*            displayEmpty*/}
      {/*            multiple*/}
      {/*            value={NFTTypeTable}*/}
      {/*            onChange={(event) => handleChange(event, 'type-table')}*/}
      {/*            renderValue={(selected) => {*/}
      {/*              if (selected.length === 0) {*/}
      {/*                return <div style={{ color: '#999' }}>차종</div>;*/}
      {/*              }*/}

      {/*              return selected*/}
      {/*                .map((value) => nftTypes.find((item) => item.value === value)?.key)*/}
      {/*                .filter(Boolean)*/}
      {/*                .join(', ');*/}
      {/*            }}*/}
      {/*            style={SELECT_FORM_STYLE}*/}
      {/*          >*/}
      {/*            <MenuItem value="all" style={{ padding: 5, gap: 5 }}>*/}
      {/*              <input*/}
      {/*                type="checkbox"*/}
      {/*                checked={NFTTypeTable.length === nftTypes.length}*/}
      {/*                onChange={(event) => {*/}
      {/*                  const checked = event.target.checked;*/}
      {/*                  setNFTTypesTable(checked ? nftTypes.map((item) => item.value) : []);*/}
      {/*                }}*/}
      {/*              />*/}
      {/*              <ListItemText primary="전체 선택" />*/}
      {/*            </MenuItem>*/}
      {/*            {nftTypes.map((item) => (*/}
      {/*              <MenuItem*/}
      {/*                key={item.value}*/}
      {/*                value={item.value}*/}
      {/*                style={{ padding: 5, gap: 5 }}*/}
      {/*              >*/}
      {/*                <input*/}
      {/*                  type="checkbox"*/}
      {/*                  checked={NFTTypeTable.includes(item.value)}*/}
      {/*                  onChange={(event) => {*/}
      {/*                    const checked = event.target.checked;*/}
      {/*                    setNFTTypesTable((prevNFTTypesTable) => {*/}
      {/*                      if (checked) {*/}
      {/*                        return [...prevNFTTypesTable, item.value];*/}
      {/*                      } else {*/}
      {/*                        return prevNFTTypesTable.filter((value) => value !== item.value);*/}
      {/*                      }*/}
      {/*                    });*/}
      {/*                  }}*/}
      {/*                />*/}
      {/*                <ListItemText primary={item.key} />*/}
      {/*              </MenuItem>*/}
      {/*            ))}*/}
      {/*          </Select>*/}
      {/*        </FormControl>*/}

      {/*        <FormControl id={"formController"}>*/}
      {/*          <Select*/}
      {/*            displayEmpty*/}
      {/*            multiple*/}
      {/*            value={NFTGradeTable}*/}
      {/*            onChange={(event) => handleChange(event, 'grade-table')}*/}
      {/*            renderValue={(selected) => {*/}
      {/*              if (selected.length === 0) {*/}
      {/*                return <div style={{ color: '#999' }}>차량 등급</div>;*/}
      {/*              }*/}

      {/*              return selected*/}
      {/*                .map((value) => nftGrades.find((item) => item.value === value)?.key)*/}
      {/*                .filter(Boolean)*/}
      {/*                .join(', ');*/}
      {/*            }}*/}
      {/*            style={SELECT_FORM_STYLE}*/}
      {/*          >*/}
      {/*            <MenuItem value="all" style={{ padding: 5, gap: 5 }}>*/}
      {/*              <input*/}
      {/*                type="checkbox"*/}
      {/*                checked={NFTGradeTable.length === nftGrades.length}*/}
      {/*                onChange={(event) => {*/}
      {/*                  const checked = event.target.checked;*/}
      {/*                  setNFTGradesTable(checked ? nftGrades.map((item) => item.value) : []);*/}
      {/*                }}*/}
      {/*              />*/}
      {/*              <ListItemText primary="전체 선택" />*/}
      {/*            </MenuItem>*/}
      {/*            {nftGrades.map((item) => (*/}
      {/*              <MenuItem*/}
      {/*                key={item.value}*/}
      {/*                value={item.value}*/}
      {/*                style={{ padding: 5, gap: 5 }}*/}
      {/*              >*/}
      {/*                <input*/}
      {/*                  type="checkbox"*/}
      {/*                  checked={NFTGradeTable.includes(item.value)}*/}
      {/*                  onChange={(event) => {*/}
      {/*                    const checked = event.target.checked;*/}
      {/*                    setNFTGradesTable((prevNFTGradesTable) => {*/}
      {/*                      if (checked) {*/}
      {/*                        return [...prevNFTGradesTable, item.value];*/}
      {/*                      } else {*/}
      {/*                        return prevNFTGradesTable.filter((value) => value !== item.value);*/}
      {/*                      }*/}
      {/*                    });*/}
      {/*                  }}*/}
      {/*                />*/}
      {/*                <ListItemText primary={item.key} />*/}
      {/*              </MenuItem>*/}
      {/*            ))}*/}
      {/*          </Select>*/}
      {/*        </FormControl>*/}

      {/*        <select*/}
      {/*          className=""*/}
      {/*          value={vehicleSealTable || ''}*/}
      {/*          style={SELECT_FORM_STYLE}*/}
      {/*          onChange={(e) => {*/}
      {/*            setVehicleSealTable(e.target.value);*/}
      {/*          }}*/}
      {/*        >*/}
      {/*          {VehicleSeals.map((option) => (*/}
      {/*            <option key={option.value} value={option.value}>*/}
      {/*              {option.label}*/}
      {/*            </option>*/}
      {/*          ))}*/}
      {/*        </select>*/}

      {/*        <select*/}
      {/*          className=""*/}
      {/*          value={isPlusTable}*/}
      {/*          style={SELECT_FORM_STYLE}*/}
      {/*          onChange={(e) => {*/}
      {/*            const selectedValue =*/}
      {/*              e.target.value === 'true'*/}
      {/*                ? true*/}
      {/*                : e.target.value === 'false'*/}
      {/*                  ? false*/}
      {/*                  : '';*/}
      {/*            setIsPlusTable(selectedValue);*/}
      {/*          }}*/}
      {/*        >*/}
      {/*          {IsPlus.map((option) => (*/}
      {/*            <option key={option.value} value={option.value}>*/}
      {/*              {option.label}*/}
      {/*            </option>*/}
      {/*          ))}*/}
      {/*        </select>*/}
      {/*      </div>*/}

      {/*    </div>*/}

      {/*    <div className="sectionLine" />*/}

      {/*    {*/}
      {/*      isLoading ? (*/}
      {/*          <div className="rowDiv" style={{*/}
      {/*            width: '100%',*/}
      {/*            height: 210,*/}
      {/*            display: 'flex',*/}
      {/*            justifyContent: 'center',*/}
      {/*            padding: 5*/}
      {/*          }}>*/}
      {/*            Loading...*/}
      {/*          </div>*/}
      {/*        )*/}
      {/*        : tableData.slice(0, -1).map((data, index) => (*/}

      {/*        <div key={index}>*/}
      {/*          <div className="rowDiv" style={{*/}
      {/*            width: '100%',*/}
      {/*            height: '100%',*/}
      {/*            padding: 5*/}
      {/*          }}>*/}

      {/*            <div style={{*/}
      {/*              display: 'flex',*/}
      {/*              flexDirection: 'column',*/}
      {/*              justifyContent: 'center',*/}
      {/*              width: '100%',*/}
      {/*              height: '100%'*/}
      {/*            }}>*/}
      {/*              <div style={{*/}
      {/*                display: 'flex',*/}
      {/*                gap: 5*/}
      {/*              }}>*/}
      {/*                <div style={{*/}
      {/*                  width: '25%',*/}
      {/*                  fontSize: 14*/}
      {/*                }}>*/}
      {/*                  등록 수량<br />*/}
      {/*                  <p style={{*/}
      {/*                    fontSize: 16,*/}
      {/*                    fontWeight: 700,*/}
      {/*                    color: '#141414'*/}
      {/*                  }}>*/}
      {/*                    {*/}
      {/*                      tableData[index + 1]?.registerCount*/}
      {/*                    }*/}
      {/*                  </p>*/}
      {/*                  {DIFF_VALUE(*/}
      {/*                    tableData[index]?.registerCount,*/}
      {/*                    tableData[index + 1]?.registerCount,*/}
      {/*                    tableData[index + 1]?.targetDate*/}
      {/*                  )}*/}
      {/*                </div>*/}

      {/*                <div style={{*/}
      {/*                  width: '25%',*/}
      {/*                  fontSize: 14*/}
      {/*                }}>*/}
      {/*                  최저 등록 금액<br />*/}
      {/*                  <p style={{*/}
      {/*                    fontSize: 16,*/}
      {/*                    fontWeight: 700,*/}
      {/*                    color: '#141414'*/}
      {/*                  }}>*/}
      {/*                    {*/}
      {/*                      tableData[index + 1]?.registerMinPrice*/}
      {/*                    }*/}
      {/*                  </p>*/}
      {/*                  {DIFF_VALUE(*/}
      {/*                    tableData[index]?.registerMinPrice,*/}
      {/*                    tableData[index + 1]?.registerMinPrice,*/}
      {/*                    tableData[index + 1]?.targetDate*/}
      {/*                  )}*/}
      {/*                </div>*/}

      {/*                <div style={{*/}
      {/*                  width: '25%',*/}
      {/*                  fontSize: 14*/}
      {/*                }}>*/}
      {/*                  최고 등록 금액<br />*/}
      {/*                  <p style={{*/}
      {/*                    fontSize: 16,*/}
      {/*                    fontWeight: 700,*/}
      {/*                    color: '#141414'*/}
      {/*                  }}>*/}
      {/*                    {*/}
      {/*                      tableData[index + 1]?.registerMaxPrice*/}
      {/*                    }*/}
      {/*                  </p>*/}
      {/*                  {DIFF_VALUE(*/}
      {/*                    tableData[index]?.registerMaxPrice,*/}
      {/*                    tableData[index + 1]?.registerMaxPrice,*/}
      {/*                    tableData[index + 1]?.targetDate*/}
      {/*                  )}*/}
      {/*                </div>*/}

      {/*                <div style={{*/}
      {/*                  width: '25%',*/}
      {/*                  fontSize: 14*/}
      {/*                }}>*/}
      {/*                  평균 등록 금액<br />*/}
      {/*                  <p style={{*/}
      {/*                    fontSize: 16,*/}
      {/*                    fontWeight: 700,*/}
      {/*                    color: '#141414'*/}
      {/*                  }}>*/}
      {/*                    {*/}
      {/*                      tableData[index + 1]?.registerAveragePrice*/}
      {/*                    }*/}
      {/*                  </p>*/}
      {/*                  {DIFF_VALUE(*/}
      {/*                    tableData[index]?.registerAveragePrice,*/}
      {/*                    tableData[index + 1]?.registerAveragePrice,*/}
      {/*                    tableData[index + 1]?.targetDate*/}
      {/*                  )}*/}
      {/*                </div>*/}
      {/*              </div>*/}

      {/*            </div>*/}
      {/*          </div>*/}

      {/*          <div className="sectionLine" />*/}

      {/*          <div className="rowDiv" style={{*/}
      {/*            width: '100%',*/}
      {/*            height: '100%',*/}
      {/*            padding: 5*/}
      {/*          }}>*/}

      {/*            <div style={{*/}
      {/*              display: 'flex',*/}
      {/*              flexDirection: 'column',*/}
      {/*              justifyContent: 'center',*/}
      {/*              width: '100%',*/}
      {/*              height: '100%'*/}
      {/*            }}>*/}
      {/*              <div style={{*/}
      {/*                display: 'flex',*/}
      {/*                gap: 5*/}
      {/*              }}>*/}
      {/*                <div style={{*/}
      {/*                  width: '25%',*/}
      {/*                  fontSize: 14*/}
      {/*                }}>*/}
      {/*                  거래 수량<br />*/}
      {/*                  <p style={{*/}
      {/*                    fontSize: 16,*/}
      {/*                    fontWeight: 700,*/}
      {/*                    color: '#141414'*/}
      {/*                  }}>*/}
      {/*                    {*/}
      {/*                      tableData[index + 1]?.transactionCount*/}
      {/*                    }*/}
      {/*                  </p>*/}
      {/*                  {DIFF_VALUE(*/}
      {/*                    tableData[index]?.transactionCount,*/}
      {/*                    tableData[index + 1]?.transactionCount,*/}
      {/*                    tableData[index + 1]?.targetDate*/}
      {/*                  )}*/}
      {/*                </div>*/}

      {/*                <div style={{*/}
      {/*                  width: '25%',*/}
      {/*                  fontSize: 14*/}
      {/*                }}>*/}
      {/*                  총 거래 금액<br />*/}
      {/*                  <p style={{*/}
      {/*                    fontSize: 16,*/}
      {/*                    fontWeight: 700,*/}
      {/*                    color: '#141414'*/}
      {/*                  }}>*/}
      {/*                    {*/}
      {/*                      tableData[index + 1]?.transactionTotalPrice*/}
      {/*                    }*/}
      {/*                  </p>*/}
      {/*                  {DIFF_VALUE(*/}
      {/*                    tableData[index]?.transactionTotalPrice,*/}
      {/*                    tableData[index + 1]?.transactionTotalPrice,*/}
      {/*                    tableData[index + 1]?.targetDate*/}
      {/*                  )}*/}
      {/*                </div>*/}

      {/*                <div style={{*/}
      {/*                  width: '25%',*/}
      {/*                  fontSize: 14*/}
      {/*                }}>*/}
      {/*                  평균 거래 금액<br />*/}
      {/*                  <p style={{*/}
      {/*                    fontSize: 16,*/}
      {/*                    fontWeight: 700,*/}
      {/*                    color: '#141414'*/}
      {/*                  }}>*/}
      {/*                    {*/}
      {/*                      tableData[index + 1]?.transactionAveragePrice*/}
      {/*                    }*/}
      {/*                  </p>*/}
      {/*                  {DIFF_VALUE(*/}
      {/*                    tableData[index]?.transactionAveragePrice,*/}
      {/*                    tableData[index + 1]?.transactionAveragePrice,*/}
      {/*                    tableData[index + 1]?.targetDate*/}
      {/*                  )}*/}
      {/*                </div>*/}

      {/*                <div style={{*/}
      {/*                  width: '25%',*/}
      {/*                  fontSize: 14*/}
      {/*                }}>*/}
      {/*                  총 거래 수수료<br />*/}
      {/*                  <p style={{*/}
      {/*                    fontSize: 16,*/}
      {/*                    fontWeight: 700,*/}
      {/*                    color: '#141414'*/}
      {/*                  }}>*/}
      {/*                    {*/}
      {/*                      tableData[index + 1]?.transactionTotalFee*/}
      {/*                    }*/}
      {/*                  </p>*/}
      {/*                  {DIFF_VALUE(*/}
      {/*                    tableData[index]?.transactionTotalFee,*/}
      {/*                    tableData[index + 1]?.transactionTotalFee,*/}
      {/*                    tableData[index + 1]?.targetDate*/}
      {/*                  )}*/}
      {/*                </div>*/}
      {/*              </div>*/}

      {/*            </div>*/}
      {/*          </div>*/}
      {/*        </div>*/}

      {/*      ))*/}
      {/*    }*/}


      {/*  </div>*/}

      {/*</div>*/}

      <div className="contentsArea">
          <div className="rowDiv">
            <div className="leftDiv" style={{width:'100%'}}>
              <div className={"contentTitle"}>
                등록 및 거래 현황 { `(${timeFormAPI.changeDataDate(DAYS_AGO(1))} 기준)` }
              </div>
            </div>

            <div className="rightDiv" style={{justifyContent: "flex-end"}}>
              <FormControl id={"formController"}>
                <Select
                    displayEmpty
                    multiple
                    value={NFTTypeTable}
                    onChange={(event) => handleChange(event, 'type-table')}
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <div style={{ color: '#999' }}>차량 종류</div>;
                      }

                      return selected
                          .map((value) => nftTypes.find((item) => item.value === value)?.key)
                          .filter(Boolean)
                          .join(', ');
                    }}
                    style={SELECT_FORM_STYLE}
                >
                  <MenuItem value="all" style={{ padding: 5, gap: 5 }}>
                    <input
                        type="checkbox"
                        checked={NFTTypeTable.length === nftTypes.length}
                        onChange={(event) => {
                          const checked = event.target.checked;
                          setNFTTypesTable(checked ? nftTypes.map((item) => item.value) : []);
                        }}
                    />
                    <ListItemText primary="전체 선택" />
                  </MenuItem>
                  {nftTypes.map((item) => (
                      <MenuItem
                          key={item.value}
                          value={item.value}
                          style={{ padding: 5, gap: 5 }}
                      >
                        <input
                            type="checkbox"
                            checked={NFTTypeTable.includes(item.value)}
                            onChange={(event) => {
                              const checked = event.target.checked;
                              setNFTTypesTable((prevNFTTypesTable) => {
                                if (checked) {
                                  return [...prevNFTTypesTable, item.value];
                                } else {
                                  return prevNFTTypesTable.filter((value) => value !== item.value);
                                }
                              });
                            }}
                        />
                        <ListItemText primary={item.key} />
                      </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl id={"formController"}>
                <Select
                    displayEmpty
                    multiple
                    value={NFTGradeTable}
                    onChange={(event) => handleChange(event, 'grade-table')}
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return <div style={{ color: '#999' }}>차량 등급</div>;
                      }

                      return selected
                          .map((value) => nftGrades.find((item) => item.value === value)?.key)
                          .filter(Boolean)
                          .join(', ');
                    }}
                    style={SELECT_FORM_STYLE}
                >
                  <MenuItem value="all" style={{ padding: 5, gap: 5 }}>
                    <input
                        type="checkbox"
                        checked={NFTGradeTable.length === nftGrades.length}
                        onChange={(event) => {
                          const checked = event.target.checked;
                          setNFTGradesTable(checked ? nftGrades.map((item) => item.value) : []);
                        }}
                    />
                    <ListItemText primary="전체 선택" />
                  </MenuItem>
                  {nftGrades.map((item) => (
                      <MenuItem
                          key={item.value}
                          value={item.value}
                          style={{ padding: 5, gap: 5 }}
                      >
                        <input
                            type="checkbox"
                            checked={NFTGradeTable.includes(item.value)}
                            onChange={(event) => {
                              const checked = event.target.checked;
                              setNFTGradesTable((prevNFTGradesTable) => {
                                if (checked) {
                                  return [...prevNFTGradesTable, item.value];
                                } else {
                                  return prevNFTGradesTable.filter((value) => value !== item.value);
                                }
                              });
                            }}
                        />
                        <ListItemText primary={item.key} />
                      </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <select
                  className=""
                  value={vehicleSealTable || ''}
                  style={SELECT_FORM_STYLE}
                  onChange={(e) => {
                    setVehicleSealTable(e.target.value);
                  }}
              >
                {VehicleSeals.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                ))}
              </select>

              <select
                  className=""
                  value={isPlusTable}
                  style={SELECT_FORM_STYLE}
                  onChange={(e) => {
                    const selectedValue =
                        e.target.value === 'true'
                            ? true
                            : e.target.value === 'false'
                                ? false
                                : '';
                    setIsPlusTable(selectedValue);
                  }}
              >
                {IsPlus.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                ))}
              </select>
            </div>
            </div>

        <div className="spaceDiv10"/>

        {
          isLoading ?
              <FetchLoading/>
              : <div style={{padding: "10px 15px"}}>
                <div className="rowDiv">
                  <DataItem
                      label="등록 수량"
                      value={currentData?.registerCount || 0}
                      prevValue={beforeData?.registerCount || 0}
                  />

                  <DataItem
                      label="최저 등록 금액"
                      value={currentData?.registerMinPrice}
                      prevValue={beforeData?.registerMinPrice}
                  />

                  <DataItem
                      label="최고 등록 금액"
                      value={currentData?.registerMaxPrice}
                      prevValue={beforeData?.registerMaxPrice}
                  />

                  <DataItem
                      label="평균 등록 금액"
                      value={currentData.registerAveragePrice}
                      prevValue={beforeData.registerAveragePrice}
                  />


                </div>
                {/*  rowDiv*/}

                <div className="spaceDiv10"/>
                <div className="spaceDiv10"/>

                <div className="rowDiv">

                  <DataItem
                      label="거래 수량"
                      value={currentData.transactionCount}
                      prevValue={beforeData.transactionCount}
                  />

                  <DataItem
                      label="총 거래 금액"
                      value={currentData.transactionTotalPrice}
                      prevValue={beforeData.transactionTotalPrice}
                  />

                  <DataItem
                      label="평균 거래 금액"
                      value={currentData.transactionAveragePrice}
                      prevValue={beforeData.transactionAveragePrice}
                  />

                  <DataItem
                      label="총 거래 수수료"
                      value={currentData.transactionTotalFee}
                      prevValue={beforeData.transactionTotalFee}
                  />


                </div>
                {/*  rowDiv*/}


              </div>

        }


      </div>

      <div className="spaceDiv10"/>


      <SearchContainer>
        <SearchRow>
          <SearchLabel text={"날짜"}/>
          <SearchDateRange
              startAt={startAt}
              endAt={endAt}
              setStartAt={setStartAt}
              setEndAt={setEndAt}
          />
        </SearchRow>

        <SearchRow>
          <SearchLabel text={"차량 종류"}/>
          <SearchContent>
            <FormControl id={'formController'}>
              <Select
                  displayEmpty
                  multiple
                  value={NFTType}
                  onChange={(event) => handleChange(event, 'type')}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <div style={{ color: '#999' }}>차량 종류</div>;
                    }

                    return selected
                        .map((value) => nftTypes.find((item) => item.value === value)?.key)
                        .filter(Boolean)
                        .join(', ');
                  }}
                  style={SELECT_FORM_STYLE}
              >
                <MenuItem value="all" style={{
                  padding: 5,
                  gap: 5
                }}>
                  <input
                      type="checkbox"
                      checked={NFTType.length === nftTypes.length}
                      onChange={(event) => {
                        const checked = event.target.checked;
                        setNFTTypes(checked ? nftTypes.map((item) => item.value) : []);
                      }}
                  />
                  <ListItemText primary="전체 선택"/>
                </MenuItem>
                {nftTypes.map((item) => (
                    <MenuItem
                        key={item.value}
                        value={item.value}
                        style={{
                          padding: 5,
                          gap: 5
                        }}
                    >
                      <input
                          type="checkbox"
                          checked={NFTType.includes(item.value)}
                          onChange={(event) => {
                            const checked = event.target.checked;
                            setNFTTypes((prevNFTTypes) => {
                              if (checked) {
                                return [...prevNFTTypes, item.value];
                              } else {
                                return prevNFTTypes.filter((value) => value !== item.value);
                              }
                            });
                          }}
                      />
                      <ListItemText primary={item.key}/>
                    </MenuItem>
                ))}
              </Select>
            </FormControl>
          </SearchContent>

          <SearchLabel text={"인장"}/>
          <SearchContent>
            <select
                className=""
                value={vehicleSeal || ''}
                style={SELECT_FORM_STYLE}
                onChange={(e) => {
                  setVehicleSeal(e.target.value);
                }}
            >
              {VehicleSeals.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
              ))}
            </select>
          </SearchContent>


        </SearchRow>

        <SearchRow>
          <SearchLabel text={"차량 등급"}/>
          <SearchContent>
            <FormControl id={'formController'}>
              <Select
                  displayEmpty
                  multiple
                  value={NFTGrade}
                  onChange={(event) => handleChange(event, 'grade')}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <div style={{ color: '#999' }}>차량 등급</div>;
                    }

                    return selected
                        .map((value) => nftGrades.find((item) => item.value === value)?.key)
                        .filter(Boolean)
                        .join(', ');
                  }}
                  style={SELECT_FORM_STYLE}
              >
                <MenuItem value="all" style={{
                  padding: 5,
                  gap: 5
                }}>
                  <input
                      type="checkbox"
                      checked={NFTGrade.length === nftGrades.length}
                      onChange={(event) => {
                        const checked = event.target.checked;
                        setNFTGrades(checked ? nftGrades.map((item) => item.value) : []);
                      }}
                  />
                  <ListItemText primary="전체 선택"/>
                </MenuItem>
                {nftGrades.map((item) => (
                    <MenuItem
                        key={item.value}
                        value={item.value}
                        style={{
                          padding: 5,
                          gap: 5
                        }}
                    >
                      <input
                          type="checkbox"
                          checked={NFTGrade.includes(item.value)}
                          onChange={(event) => {
                            const checked = event.target.checked;
                            setNFTGrades((prevNFTGrades) => {
                              if (checked) {
                                return [...prevNFTGrades, item.value];
                              } else {
                                return prevNFTGrades.filter((value) => value !== item.value);
                              }
                            });
                          }}
                      />
                      <ListItemText primary={item.key}/>
                    </MenuItem>
                ))}
              </Select>
            </FormControl>
          </SearchContent>

          <SearchLabel text={"플러스 여부"}/>
          <SearchContent>

            <select
                className=""
                value={isPlus}
                style={SELECT_FORM_STYLE}
                onChange={(e) => {
                  const selectedValue =
                      e.target.value === 'true'
                          ? true
                          : e.target.value === 'false'
                              ? false
                              : '';
                  setIsPlus(selectedValue);
                }}
            >
              {IsPlus.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
              ))}
            </select>

          </SearchContent>

        </SearchRow>



      </SearchContainer>

        <SearchBtnContainer
            handleSearchClick={() => {
                fetchList();
            }}
            handleResetClick={handleResetClick}
        />

      {/*<div className="contentsArea paddingAll" style={{ padding: 5 }}>*/}
      {/*  <div className="rowDiv">*/}
      {/*    <div className="titleDiv flex-space-between">*/}
      {/*      <div className="left">*/}
      {/*        등록 및 거래 내역 조회*/}
      {/*      </div>*/}

      {/*      <div className="right">*/}
      {/*      </div>*/}
      {/*    </div>*/}

      {/*    <div className="spaceDiv10"/>*/}

      {/*    <div className="descDiv" style={{ alignItems: 'center' }}>*/}

      {/*      <FormControl id={'formController'}>*/}
      {/*        <Select*/}
      {/*          displayEmpty*/}
      {/*          multiple*/}
      {/*          value={NFTType}*/}
      {/*          onChange={(event) => handleChange(event, 'type')}*/}
      {/*          renderValue={(selected) => {*/}
      {/*            if (selected.length === 0) {*/}
      {/*              return <div style={{ color: '#999' }}>차종</div>;*/}
      {/*            }*/}

      {/*            return selected*/}
      {/*              .map((value) => nftTypes.find((item) => item.value === value)?.key)*/}
      {/*              .filter(Boolean)*/}
      {/*              .join(', ');*/}
      {/*          }}*/}
      {/*          style={SELECT_FORM_STYLE}*/}
      {/*        >*/}
      {/*          <MenuItem value="all" style={{*/}
      {/*            padding: 5,*/}
      {/*            gap: 5*/}
      {/*          }}>*/}
      {/*            <input*/}
      {/*              type="checkbox"*/}
      {/*              checked={NFTType.length === nftTypes.length}*/}
      {/*              onChange={(event) => {*/}
      {/*                const checked = event.target.checked;*/}
      {/*                setNFTTypes(checked ? nftTypes.map((item) => item.value) : []);*/}
      {/*              }}*/}
      {/*            />*/}
      {/*            <ListItemText primary="전체 선택"/>*/}
      {/*          </MenuItem>*/}
      {/*          {nftTypes.map((item) => (*/}
      {/*            <MenuItem*/}
      {/*              key={item.value}*/}
      {/*              value={item.value}*/}
      {/*              style={{*/}
      {/*                padding: 5,*/}
      {/*                gap: 5*/}
      {/*              }}*/}
      {/*            >*/}
      {/*              <input*/}
      {/*                type="checkbox"*/}
      {/*                checked={NFTType.includes(item.value)}*/}
      {/*                onChange={(event) => {*/}
      {/*                  const checked = event.target.checked;*/}
      {/*                  setNFTTypes((prevNFTTypes) => {*/}
      {/*                    if (checked) {*/}
      {/*                      return [...prevNFTTypes, item.value];*/}
      {/*                    } else {*/}
      {/*                      return prevNFTTypes.filter((value) => value !== item.value);*/}
      {/*                    }*/}
      {/*                  });*/}
      {/*                }}*/}
      {/*              />*/}
      {/*              <ListItemText primary={item.key}/>*/}
      {/*            </MenuItem>*/}
      {/*          ))}*/}
      {/*        </Select>*/}
      {/*      </FormControl>*/}

      {/*      <FormControl id={'formController'}>*/}
      {/*        <Select*/}
      {/*          displayEmpty*/}
      {/*          multiple*/}
      {/*          value={NFTGrade}*/}
      {/*          onChange={(event) => handleChange(event, 'grade')}*/}
      {/*          renderValue={(selected) => {*/}
      {/*            if (selected.length === 0) {*/}
      {/*              return <div style={{ color: '#999' }}>차량 등급</div>;*/}
      {/*            }*/}

      {/*            return selected*/}
      {/*              .map((value) => nftGrades.find((item) => item.value === value)?.key)*/}
      {/*              .filter(Boolean)*/}
      {/*              .join(', ');*/}
      {/*          }}*/}
      {/*          style={SELECT_FORM_STYLE}*/}
      {/*        >*/}
      {/*          <MenuItem value="all" style={{*/}
      {/*            padding: 5,*/}
      {/*            gap: 5*/}
      {/*          }}>*/}
      {/*            <input*/}
      {/*              type="checkbox"*/}
      {/*              checked={NFTGrade.length === nftGrades.length}*/}
      {/*              onChange={(event) => {*/}
      {/*                const checked = event.target.checked;*/}
      {/*                setNFTGrades(checked ? nftGrades.map((item) => item.value) : []);*/}
      {/*              }}*/}
      {/*            />*/}
      {/*            <ListItemText primary="전체 선택"/>*/}
      {/*          </MenuItem>*/}
      {/*          {nftGrades.map((item) => (*/}
      {/*            <MenuItem*/}
      {/*              key={item.value}*/}
      {/*              value={item.value}*/}
      {/*              style={{*/}
      {/*                padding: 5,*/}
      {/*                gap: 5*/}
      {/*              }}*/}
      {/*            >*/}
      {/*              <input*/}
      {/*                type="checkbox"*/}
      {/*                checked={NFTGrade.includes(item.value)}*/}
      {/*                onChange={(event) => {*/}
      {/*                  const checked = event.target.checked;*/}
      {/*                  setNFTGrades((prevNFTGrades) => {*/}
      {/*                    if (checked) {*/}
      {/*                      return [...prevNFTGrades, item.value];*/}
      {/*                    } else {*/}
      {/*                      return prevNFTGrades.filter((value) => value !== item.value);*/}
      {/*                    }*/}
      {/*                  });*/}
      {/*                }}*/}
      {/*              />*/}
      {/*              <ListItemText primary={item.key}/>*/}
      {/*            </MenuItem>*/}
      {/*          ))}*/}
      {/*        </Select>*/}
      {/*      </FormControl>*/}

      {/*      <select*/}
      {/*        className=""*/}
      {/*        value={vehicleSeal || ''}*/}
      {/*        style={SELECT_FORM_STYLE}*/}
      {/*        onChange={(e) => {*/}
      {/*          setVehicleSeal(e.target.value);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        {VehicleSeals.map((option) => (*/}
      {/*          <option key={option.value} value={option.value}>*/}
      {/*            {option.label}*/}
      {/*          </option>*/}
      {/*        ))}*/}
      {/*      </select>*/}

      {/*      <select*/}
      {/*        className=""*/}
      {/*        value={isPlus}*/}
      {/*        style={SELECT_FORM_STYLE}*/}
      {/*        onChange={(e) => {*/}
      {/*          const selectedValue =*/}
      {/*            e.target.value === 'true'*/}
      {/*              ? true*/}
      {/*              : e.target.value === 'false'*/}
      {/*                ? false*/}
      {/*                : '';*/}
      {/*          setIsPlus(selectedValue);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        {IsPlus.map((option) => (*/}
      {/*          <option key={option.value} value={option.value}>*/}
      {/*            {option.label}*/}
      {/*          </option>*/}
      {/*        ))}*/}
      {/*      </select>*/}

      {/*      <div className="descDiv dateSmall">*/}
      {/*        <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*          <DatePicker*/}
      {/*            onChange={(date) => {*/}
      {/*              setStartAt(date.format('YYYY-MM-DD'));*/}
      {/*            }}*/}
      {/*            value={startAt}*/}
      {/*            renderInput={(params) => (*/}
      {/*              <TextField {...params} variant="standard"/>*/}
      {/*            )}*/}
      {/*          />*/}
      {/*        </LocalizationProvider>*/}

      {/*        <LocalizationProvider dateAdapter={AdapterMoment}>*/}
      {/*          <DatePicker*/}
      {/*            onChange={(date) => {*/}
      {/*              setEndAt(date.format('YYYY-MM-DD'));*/}
      {/*            }}*/}
      {/*            value={endAt}*/}
      {/*            renderInput={(params) => (*/}
      {/*              <TextField {...params} variant="standard"/>*/}
      {/*            )}*/}
      {/*          />*/}
      {/*        </LocalizationProvider>*/}

      {/*      </div>*/}

      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeToken === 7 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(7);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        주*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeToken === 30 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(30);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        월*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`dateSelectBox ${activeDateRangeToken === 90 ? 'active' : ''*/}
      {/*        }`}*/}
      {/*        onClick={() => {*/}
      {/*          setActiveDateRangeToken(90);*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        3개월*/}
      {/*      </button>*/}

      {/*      <button*/}
      {/*        className={`typeSelectBox ${graphType === 'count' ? 'active' : ''}`}*/}
      {/*        onClick={() => {*/}
      {/*          setGraphType('count');*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        수량*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`typeSelectBox ${graphType === 'token' ? 'active' : ''}`}*/}
      {/*        onClick={() => {*/}
      {/*          setGraphType('token');*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        금액*/}
      {/*      </button>*/}
      {/*      <button*/}
      {/*        className={`typeSelectBox ${graphType === 'fee' ? 'active' : ''}`}*/}
      {/*        onClick={() => {*/}
      {/*          setGraphType('fee');*/}
      {/*        }}*/}
      {/*      >*/}
      {/*        수수료*/}
      {/*      </button>*/}

      {/*      <button className="defaultBtn"*/}
      {/*              onClick={() => {*/}
      {/*                // handleSearchClick;*/}
      {/*                fetchList();*/}
      {/*              }}*/}
      {/*      >*/}
      {/*        조회*/}
      {/*      </button>*/}

      {/*      /!*<button className="defaultBtn fit purple" onClick={handleClickDownload}>*!/*/}
      {/*      /!*  <img src={BtnIcons.downloadIcon} alt={'다운로드'}/>*!/*/}
      {/*      /!*  엑셀 다운로드*!/*/}
      {/*      /!*</button>*!/*/}

      {/*    </div>*/}
      {/*  </div>*/}


      {/*  /!*<div className="spaceDiv10"/>*!/*/}
      {/*  /!*{*!/*/}
      {/*  /!*  isLoadingGraph ? (*!/*/}
      {/*  /!*      <div className="rowDiv" style={{*!/*/}
      {/*  /!*        width: '100%',*!/*/}
      {/*  /!*        height: 520,*!/*/}
      {/*  /!*        display: 'flex',*!/*/}
      {/*  /!*        justifyContent: 'center',*!/*/}
      {/*  /!*        padding: 'unset'*!/*/}
      {/*  /!*      }}>*!/*/}
      {/*  /!*        Loading...*!/*/}
      {/*  /!*      </div>*!/*/}
      {/*  /!*    )*!/*/}
      {/*  /!*    : <div className="rowDiv" style={{*!/*/}
      {/*  /!*  height: 520,*!/*/}
      {/*  /!*  padding: 'unset'*!/*/}
      {/*  /!*}}>*!/*/}
      {/*  /!*  <div className="descDiv" style={{*!/*/}
      {/*  /!*    width: '100%',*!/*/}
      {/*  /!*    height: '100%'*!/*/}
      {/*  /!*  }}>*!/*/}
      {/*  /!*    <SimpleLine data={lineData}/>*!/*/}
      {/*  /!*  </div>*!/*/}
      {/*  /!*</div>*!/*/}
      {/*  /!*}*!/*/}
      {/*</div>*/}

      <div className="spaceDiv10"/>

      {/*<SearchContainer>*/}
      {/*  <SearchRow>*/}
      {/*    <SearchLabel text={"차종"}/>*/}
      {/*    <SearchContent>*/}
      {/*      /!*<select name="" id="">*!/*/}
      {/*      /!*  {*!/*/}
      {/*      /!*    nftTypes.map((option) => (*!/*/}
      {/*      /!*        <option key={option.value} selected={needNftType}>{option.key}</option>*!/*/}
      {/*      /!*    ))*!/*/}
      {/*      /!*  }*!/*/}

      {/*      /!*</select>*!/*/}

      {/*      {*/}
      {/*        nftTypes.map((option) => (*/}
      {/*            <>*/}
      {/*              <input type="checkbox"*/}
      {/*                     key={option.value}*/}
      {/*                     value={option.key}*/}
      {/*              />*/}
      {/*              <label htmlFor="">{option.key}</label>*/}
      {/*              <div className="spaceDiv10"/>*/}
      {/*              <div className="spaceDiv10"/>*/}
      {/*            </>*/}
      {/*        ))*/}
      {/*      }*/}



      {/*    </SearchContent>*/}

      {/*  </SearchRow>*/}

      {/*</SearchContainer>*/}

      <BOTable
          schema={schema}
          rows={data}
          loading={isLoadingGraph}
          maxHeight={"55vh"}
      />


      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}

    </div>
  );
}

export default car;
